import { Modal } from '@octano/global-ui';

export interface DocumentPreviewModalProps {
  isOpen: boolean;
  url: string | null;
  title?: string;
  onClose: () => void;
}

export function DocumentPreviewModal({
  isOpen,
  url,
  title,
  onClose,
}: DocumentPreviewModalProps) {
  return (
    <Modal isOpen={isOpen} toggle={onClose} size="lg">
      {title && (
        <h1 className="text-dark fs-20 mt-3 mb-4 text-center">{title}</h1>
      )}
      {url && (
        <iframe
          src={url}
          title={title}
          style={{ width: '100%', height: '75vh', border: 'none' }}
        />
      )}
    </Modal>
  );
}
